import * as React from 'react';

import {deserializeFieldNames} from 'nutshell-core/entities/deserialize-fields';
import type {FilterObject} from 'nutshell-core/types';

import {LoadingPage} from 'shells/loading-page/loading-page';

import type {
    DripSequenceFragment as DripSequence,
    SmsDripSequenceFragment as SmsDripSequence,
} from 'nutshell-graphql-types';

import {getReportDefaultFields} from '../../../reports/report-constants';
import type {ReportURLParams} from '../../../reports/report-types';

import type {StatusFilter} from './drip-sequence-recipient-engagement-filter';
import {DripSequenceRecipientListContainer} from './drip-sequence-recipient-list-container';

type Props = {
    dripSequence: DripSequence | null | undefined | SmsDripSequence | null | undefined;
    activeFilters: FilterObject[];
    onParamChange: (arg1: any, arg2: boolean) => any;
    urlParams: ReportURLParams<'contacts'>;
    onRemoveAllFilters: () => void;
    statusFilters: StatusFilter[];
    fieldFilterFunction: (arg1: string) => boolean;
};

export function DripSequenceRecipientList(props: Props) {
    if (!props.dripSequence) {
        return <LoadingPage />;
    }

    // List params/defaults are the same as editions
    const listParams = props.urlParams.list || {};
    const listSelectedFields =
        // @ts-expect-error
        listParams.fields && listParams.fields.contacts
            ? // @ts-expect-error
              deserializeFieldNames(listParams.fields.contacts)
            : deserializeFieldNames(getReportDefaultFields('dripEditionEngagement'));

    const search = props.urlParams.q || '';

    const unfilteredCount =
        props.dripSequence.engagementStats && props.dripSequence.engagementStats.totalSentCount;

    return (
        <div className='routed-report-content' id='drip-sequence-recipient-list'>
            <DripSequenceRecipientListContainer
                dripSequenceId={props.dripSequence.id}
                filters={props.activeFilters}
                search={search}
                selectedPage={
                    // @ts-expect-error
                    listParams.page && Number(listParams.page) ? Number(listParams.page) : 1
                }
                unfilteredCount={unfilteredCount || 0}
                onRemoveAllFilters={props.onRemoveAllFilters}
                // @ts-expect-error
                selectedSortField={listParams.sort}
                selectedFields={listSelectedFields}
                onParamChange={props.onParamChange}
                urlParams={props.urlParams}
                statusFilters={props.statusFilters}
                fieldFilterFunction={props.fieldFilterFunction}
            />
        </div>
    );
}
